"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.REFRESH_TOKEN_EXPIRATION_DAYS = exports.AuthenticationTokens = void 0;var _storage = require("../storage");
var _const = require("../const");
var _utils = require("../utils");

const REFRESH_TOKEN_EXPIRATION_DAYS = 7;exports.REFRESH_TOKEN_EXPIRATION_DAYS = REFRESH_TOKEN_EXPIRATION_DAYS;







class AuthenticationTokens {




  constructor(tokens) {
    this.accessToken = tokens === null || tokens === void 0 ? void 0 : tokens.accessToken;
    this.refreshToken = tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken;
    this.idToken = tokens === null || tokens === void 0 ? void 0 : tokens.idToken;
    Object.freeze(this);
  }

  /**
   * Gets Authentication Tokens from local storage
   * @return {AuthenticationTokens}
   */
  static get() {
    const refreshToken = (0, _storage.getLocalStorageWithExpiration)(_const.AUTH_REFRESH_STORAGE_KEY);
    const accessToken = (0, _storage.getLocalStorageWithExpiration)(_const.AUTH_ACCESS_STORAGE_KEY);
    const idToken = (0, _storage.getLocalStorageWithExpiration)(_const.AUTH_ID_STORAGE_KEY);
    return new AuthenticationTokens({
      accessToken,
      idToken,
      refreshToken
    });
  }

  /**
   * Sets user's credentials to local storage
   * @param {AuthenticationTokens} authentication
   */
  static set(authentication) {
    const token = (0, _utils.parseToken)(authentication === null || authentication === void 0 ? void 0 : authentication.accessToken);
    if (!token) {
      return;
    }
    const expiration = new Date(token.exp * 1000);
    if (authentication.accessToken) {
      (0, _storage.setLocalStorageWithExpiration)(
        _const.AUTH_ACCESS_STORAGE_KEY,
        authentication.accessToken,
        expiration
      );
    }
    if (authentication.idToken) {
      (0, _storage.setLocalStorageWithExpiration)(
        _const.AUTH_ID_STORAGE_KEY,
        authentication.idToken,
        expiration
      );
    }
    if (authentication.refreshToken) {
      (0, _storage.setLocalStorageWithExpiration)(
        _const.AUTH_REFRESH_STORAGE_KEY,
        authentication.refreshToken,
        60 * 60 * REFRESH_TOKEN_EXPIRATION_DAYS //expire x-days
      );
    }
  }

  /**
   * Clears all Authentication in local storage
   */
  static clear() {
    (0, _storage.removeFromLocalStorage)(_const.AUTH_ACCESS_STORAGE_KEY);
    (0, _storage.removeFromLocalStorage)(_const.AUTH_ID_STORAGE_KEY);
    (0, _storage.removeFromLocalStorage)(_const.AUTH_REFRESH_STORAGE_KEY);
  }
}exports.AuthenticationTokens = AuthenticationTokens;;